import { addTextValidation, patterns } from '../../common/constants/variables/globalVariables';
export class ValidateFields {
    constructor(formState) {
        this.formID = ''; // Form modal identifier
        this.formState = formState;
        // Binds the functions so they maintain the context of the class
        this.validateForm = this.validateForm.bind(this);
        this.changeInputRadio = this.changeInputRadio.bind(this);
        this.changeCheckbox = this.changeCheckbox.bind(this);
        this.changeSelect = this.changeSelect.bind(this);
        this.changeSelectCountryCode = this.changeSelectCountryCode.bind(this);
        this.validateInputs = this.validateInputs.bind(this);
    }
    /**
     * countValid
     * Function that counts the number of valid fields in the form to enable submission.
     * @param {string} value The form modal ID.
     * @returns {void}
     */
    countValid(value) {
        // Gets the number of fields with the 'valid' class
        let inputValids = document.querySelectorAll(value + ' input.valid:not(.d-none), ' + value + ' select.valid:not(.d-none)').length;
        const buttons = document.querySelectorAll(value + ' .btn-form');
        let valueFields = this.formState.manageState('valueFields'); // Number of fields that need to be valid to enable submission;
        // Enables the button if the conditions are met
        if (inputValids == valueFields) {
            buttons.forEach(button => {
                button.disabled = false;
            });
        }
        else {
            buttons.forEach(button => {
                button.disabled = true;
            });
        }
    }
    validateSubmitForm(form, typeForm) {
        let fields = this.getFieldsForm(typeForm);
        let readyToSendForm = true;
        fields.forEach(selector => {
            const fieldElements = form.querySelectorAll(selector);
            const isValid = Array.from(fieldElements).some(field => field.classList.contains('valid'));
            if (!isValid && fieldElements.length > 0) {
                Array.from(fieldElements).forEach((fieldElement) => {
                    fieldElement.classList.add('invalid');
                });
                readyToSendForm = false;
            }
        });
        return readyToSendForm;
    }
    getFieldsForm(typeForm) {
        let baseFields = [
            '[name="name"]',
            '[name="lastname"]',
            '[name="email"]',
            '[name="phone"]',
            '[name="habitar_invertir"]',
            '[name="checkboxForm"]'
        ];
        const calculatorFields = {
            'simulator-subsidy': ['[name="checkboxForm"]'],
            'simulator-mortgage': [
                '[name="input_credito"]',
                '[name="plazo"]',
                '[name="checkboxForm"]'
            ],
        };
        const notaryIndebtednessFields = ['[name="city"]', '[name="propertyPrice"]'];
        const mortgageDownFields = [...notaryIndebtednessFields, '[name="input_credito"]'];
        const simulatorFields = {
            'simulator-subsidy': [
                '[name="ingreso"]',
                '[name="city"]'
            ],
            'simulator-mortgage': [
                ...mortgageDownFields,
                '[name="ingreso"]',
                '[name="plazo"]'
            ],
            'simulator-down-payment': [
                ...mortgageDownFields,
                '[name="fecha_cuota"]',
            ],
            'simulator-indebtedness': [
                ...notaryIndebtednessFields,
                '[name="ingreso"]',
                '[name="plazo"]',
                '[name="vis_novis"]'
            ],
            'simulator-notary': [
                ...notaryIndebtednessFields
            ],
        };
        const preregistroFields = {
            'blog': [
                '[name="city"]',
                '[name="min_budget"]',
            ],
            'stepperForm': [
                '[name="ingreso"]',
                '[name="purchase_time"]',
            ],
            'fair': [
                '[name="city"]',
                '[name="rango_de_precio"]',
            ],
        };
        const productFields = ['[name="cargo"]', '[name="company"]', '[name="service"'];
        const serviceFields = {
            'dataliving': [
                ...productFields
            ],
            'dataliving_modal': [
                ...productFields
            ],
            'service_modal': [
                ...productFields
            ],
            'fair': [
                '[name="sector"]',
            ],
        };
        let fields = baseFields;
        const nameCalculator = this.formState.manageState('openCalculator');
        const nameCalculatorFields = nameCalculator ? nameCalculator.replace('full-', '') : '';
        let formName = this.formState.manageState('formName');
        if (typeForm == 'Preregistro') {
            const formPreregistro = Object.keys(preregistroFields).find(key => formName.includes(key)) || '';
            fields = [...baseFields, ...preregistroFields[formPreregistro]];
        }
        else if (typeForm == 'Servicios') {
            formName = formName.toLowerCase().split('#form_')[1];
            if (formName.includes('dataliving')) {
                const index = baseFields.indexOf('[name="email"]');
                if (index !== -1) {
                    baseFields[index] = '[name="corporateEmail"]';
                }
            }
            baseFields = baseFields.filter(field => field !== '[name="habitar_invertir"]');
            fields = [...baseFields, ...serviceFields[formName]];
        }
        else if (typeForm == 'Calculadora') {
            fields = (nameCalculator.includes('full'))
                ? [...baseFields, ...(calculatorFields[nameCalculatorFields] || [])]
                : calculatorFields[nameCalculator];
        }
        else if (typeForm == 'Simulador') {
            fields = [...baseFields, ...(simulatorFields[nameCalculatorFields])];
        }
        return fields;
    }
    /**
     * validateForm
     * Main function for validating the form fields.
     * It runs when the user types in a field.
     * @returns {void}
     */
    validateForm() {
        // Gets all inputs with the 'input-form' class
        const inputs = document.querySelectorAll('.input-form');
        // Adds a 'keyup' event listener to each input to validate while typing
        inputs.forEach((input) => {
            input.addEventListener('keyup', (e) => {
                const target = e.target;
                const nameAttr = target.getAttribute('name');
                const container = input.closest('.js-content-form');
                const containterID = container === null || container === void 0 ? void 0 : container.getAttribute('id');
                const formName = this.formState.manageState('formName');
                if (formName != containterID) {
                    this.formState.manageState('formName', '#' + containterID);
                }
                // Validates the field with the corresponding pattern
                if (nameAttr && patterns[nameAttr]) {
                    this.validateInputs(target);
                }
                // Specific validation for property price field minimum value
                if (formName != 'subsidy' && nameAttr === 'propertyPrice') {
                    const priceValue = target.value;
                    if (Number(priceValue.replace(/[^\d]/g, '')) < 128115000) {
                        target.classList.remove('valid');
                        target.classList.add('invalid');
                    }
                }
            });
            input.addEventListener("dragover", (e) => {
                e.preventDefault();
            });
            input.addEventListener("drop", (e) => {
                e.preventDefault();
            });
        });
        const texto_valor = document.querySelectorAll('.texto-email');
        addTextValidation(texto_valor);
        // Calls the function to validate checkboxes
        this.checkboxValidate();
    }
    /**
     * Validates the input field based on a given regular expression or specific logic for price fields.
     * @param {HTMLInputElement} field - The input field to be validated. This should be an HTML input element.
     * @returns {void}
     */
    validateInputs(field) {
        const regex = patterns[field.name];
        this.formID = this.formState.manageState('formName'); // Gets the form modal ID
        let valid = false;
        valid = regex.test(field.value); // Validates the field with the regex pattern
        if (field.name === 'ingreso') {
            const numericValue = Number(field.value.replace(/[^\d]/g, ''));
            const salarioMinimo = 1750905;
            if (numericValue < salarioMinimo) {
                valid = false;
            }
        }
        if (field.name == 'phone') {
            if (document.querySelector(this.formID + ' #select-country-code').innerHTML != '+ 57') {
                patterns.phone = /^(?!.*(.)\1\1\1)(?!.*1234)([0-9]){9,14}$/;
            }
        }
        if (valid) {
            field.classList.add('valid');
            field.classList.remove('invalid');
            this.countValid(this.formID); // Counts the valid fields
        }
        else {
            field.classList.add('invalid');
            field.classList.remove('valid');
        }
    }
    /**
     * changeCheckbox
     * Function that is executed when the state of a checkbox or radio button changes.
     * @param {Event} e The change event.
     * @returns {void}
     */
    changeCheckbox(e) {
        this.formID = this.formState.manageState('formName'); // Gets the form modal ID
        const target = e === null || e === void 0 ? void 0 : e.target;
        if (target.checked) {
            target.classList.add('valid');
            target.classList.remove('invalid');
        }
        else {
            target.classList.add('invalid');
            target.classList.remove('valid');
        }
        this.countValid(this.formID);
    }
    /**
     * changeSelect
     * Function that is executed when the state of a select changes.
     * @param {Event} e The change event.
     * @returns {void}
     */
    changeSelect(e) {
        this.formID = this.formState.manageState('formName');
        const target = e === null || e === void 0 ? void 0 : e.target;
        if (target.value && target.value !== "default") {
            target.classList.add('valid');
            target.classList.remove('invalid');
        }
        else {
            target.classList.add('invalid');
            target.classList.remove('valid');
        }
        this.countValid(this.formID);
    }
    /**
     * @description Method that handles the change of the selected country code in a form.
     * @param {Event} e - Event triggered when a new country code is selected.
     * @returns {void}
     */
    changeSelectCountryCode(e) {
        var _a, _b;
        this.formID = this.formState.manageState('formName'); // Gets the form modal ID
        let indicator = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.getAttribute('data-indicator')) === null || _b === void 0 ? void 0 : _b.replace('+ ', '');
        this.formState.manageState('countryCode', indicator);
        document.querySelector(this.formID + ' #select-country-code').innerHTML = indicator || '';
        if (document.querySelector(this.formID + ' #select-country-code').innerHTML != '+ 57') {
            patterns.phone = /^(?!.*(.)\1\1\1)(?!.*1234)([0-9]){9,14}$/;
        }
        this.countValid(this.formID);
    }
    /**
     * checkboxValidate
     * Function that adds a 'change' listener to all checkboxes and form checkboxes.
     * @returns {void}
     */
    checkboxValidate() {
        let selectcheckBox = Array.from(document.getElementsByClassName('checkbox-cards'));
        if (selectcheckBox) {
            selectcheckBox.forEach(select => select.addEventListener('change', this.changeCheckbox));
        }
    }
    /**
     * changeInputRadio
     * Function that is executed when a purchase option (radio button) is selected.
     * Updates the class of the radio buttons based on the selected option.
     * @param {string} selectedValue The selected value.
     * @returns {void}
     */
    changeInputRadio(selectedValue) {
        const formSelector = this.formState.manageState('formName');
        this.formID = formSelector;
        const selectedRadio = document.querySelector(`${formSelector} input[type="radio"][value="${selectedValue}"]`);
        if (!selectedRadio)
            return;
        const radios = document.querySelectorAll(`${formSelector} input[type="radio"][name="${selectedRadio.name}"]`);
        radios.forEach(radio => {
            const isSelected = radio.value === selectedValue;
            radio.checked = isSelected;
            if (isSelected) {
                radio.classList.add('valid');
            }
            else {
                radio.classList.remove('valid');
            }
            radio.classList.remove('invalid');
        });
        selectedRadio.dispatchEvent(new Event('change'));
        this.countValid(this.formID);
    }
}
